import { decodeGetter } from '@/app/common/components/ag-grid/configs';
import BadgeRenderer from '@/app/common/components/CellRenderers/BadgeRenderer';
import ProtocolRenderer from '@/app/common/components/CellRenderers/ProtocolRenderer';
import URLRenderer from '@/app/common/components/CellRenderers/URLRenderer';
import { getColor } from '@/helpers/utils';
import type { ColumnMenuTab } from 'ag-grid-community';
import type { ReactElement } from 'react';

const menuTabs: ColumnMenuTab[] = [
  'columnsMenuTab',
  'filterMenuTab',
  'generalMenuTab'
];

const SimpleURLRenderer = URLRenderer as (props: {
  url?: string | null;
}) => ReactElement;

export const density: any[] = [
  {
    searchable: true,
    field: 'word',
    type: 'string',
    menuTabs,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    filterValueGetter: decodeGetter,
    title: 'کلمه کلیدی',
    minWidth: 145,
    flex: 1
  },
  {
    searchable: true,
    field: 'count',
    type: 'number',
    menuTabs,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    title: 'تعداد ',
    width: 120
  },
  {
    searchable: true,
    field: 'density',
    type: 'string',
    menuTabs,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    title: 'درصد چگالی',
    width: 90,
    valueFormatter: (params: { value?: number }) =>
      ((params.value ?? 0) * 100).toFixed(2) + '%'
  }
];
export const headers: any[] = [
  {
    searchable: true,
    field: 'tagName',
    type: 'number',
    menuTabs,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    title: 'نوع تگ',
    width: 80,
    cellRenderer: (params: { value?: string }) =>
      params.value ? params.value.toUpperCase() : '',
    valueFormatter: (params: { value?: string }) =>
      params.value ? params.value.toUpperCase() : ''
  },
  {
    searchable: true,
    field: 'text',
    type: 'string',
    menuTabs,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    filterValueGetter: decodeGetter,
    title: 'متن تگ',
    minWidth: 145,
    flex: 1
  },
  {
    searchable: true,
    field: 'i',
    type: 'number',
    menuTabs,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    title: 'موقعیت',
    width: 90
  }
];
export const links: any[] = [
  {
    searchable: true,
    field: 'href',
    type: 'string',
    menuTabs,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    title: 'نشانی پیوند',
    flex: 1,
    minWidth: 140,
    filterValueGetter: decodeGetter,
    cellRenderer: (params: { value?: string }) => (
      <SimpleURLRenderer url={params.value} />
    )
  },
  {
    searchable: true,
    field: 'title',
    type: 'string',
    menuTabs,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    filterValueGetter: decodeGetter,
    title: 'عنوان',
    width: 110
  },
  {
    searchable: true,
    field: 'title',
    type: 'anchor',
    menuTabs,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    filterValueGetter: decodeGetter,
    title: 'انکر تکست',
    width: 110
  },
  {
    searchable: true,
    field: 'occurrenceCount',
    type: 'number',
    menuTabs,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    title: 'تعداد',
    width: 90
  },
  {
    searchable: true,
    field: 'isInternal',
    type: 'boolean',
    menuTabs,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    title: 'داخلی هست؟',
    width: 90,
    cellRenderer: (params: { value?: boolean }) => (
      <BadgeRenderer
        color={params.value ? getColor('primary') : getColor('info')}
        textColor={getColor('black')}
        text={params.value ? 'آره' : 'نه'}
      />
    )
  },
  {
    field: 'isHttps',
    type: 'boolean',
    menuTabs,
    searchable: true,
    floatingFilter: true,
    filter: 'agTextColumnFilter',
    width: 120,
    title: 'پروتکل',
    cellRenderer: (params: { value?: boolean }) => (
      <ProtocolRenderer protocol={params.value ? 'https' : 'http'} />
    )
  },
  {
    searchable: true,
    field: 'isUnique',
    type: 'boolean',
    menuTabs,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    title: 'یکتا هست؟',
    width: 90,
    cellRenderer: (params: { value?: boolean }) => (
      <BadgeRenderer
        color={params.value ? getColor('primary') : getColor('info')}
        textColor={getColor('black')}
        text={params.value ? 'آره' : 'نه'}
      />
    )
  }
];
export const images: any[] = [
  {
    searchable: true,
    field: 'src',
    type: 'string',
    menuTabs,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    title: 'نشانی تصویر',
    flex: 1,
    minWidth: 140,
    filterValueGetter: decodeGetter,
    cellRenderer: (params: { value?: string }) => (
      <SimpleURLRenderer url={params.value} />
    )
  },
  {
    searchable: true,
    field: 'alt',
    type: 'string',
    menuTabs,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    filterValueGetter: decodeGetter,
    title: 'متن جایگزین‌تصویر',
    width: 145
  },
  {
    searchable: true,
    field: 'title',
    type: 'string',
    menuTabs,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    filterValueGetter: decodeGetter,
    title: 'عنوان',
    width: 110
  },
  {
    searchable: true,
    field: 'name',
    type: 'string',
    menuTabs,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    filterValueGetter: decodeGetter,
    title: 'نام تصویر',
    width: 110
  },
  {
    field: 'isHttps',
    type: 'boolean',
    menuTabs,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    searchable: true,
    width: 120,
    title: 'پروتکل',
    cellRenderer: (params: { value?: boolean }) => (
      <ProtocolRenderer protocol={params.value ? 'https' : 'http'} />
    )
  }
];
export const metas: any[] = [
  {
    searchable: true,
    field: 'name',
    type: 'string',
    menuTabs,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    title: 'نام',
    width: 180
  },
  {
    searchable: true,
    field: 'value',
    type: 'string',
    menuTabs,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    title: 'مقدار',
    minWidth: 110,
    flex: 1
  },
  {
    searchable: true,
    field: 'mode',
    type: 'string',
    menuTabs,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    title: 'نوع',
    width: 110
  }
];
